import React, { useState } from "react";
import "./Accordion.css";
import img1 from "./Mask1.png";
import img2 from "./Mask2.png";
import { Stack, Switch, Text } from "@chakra-ui/react";
import ToggleBtn from "../ToggleBtn/ToggleBtn";

const Accordion = () => {
  const [isItemHovered, setIsItemHovered] = useState(0);

  const handleItemHover = (val) => {
    setIsItemHovered(val);
  };

  return (
    <>
      <section id="accordion">
        <div data-aos="fade-up" data-aos-duration="3000">
        <div className="accor-head">Our Industry Work</div>
        <div className="accor-head2">Case Studies</div>
        </div>
      
        <div data-aos="fade-up" data-aos-duration="3000" class="swiper-container">
          <div class="swiper-wrapper">
            <div class="swiper-slide">
              <div class="container-general">
                <div class="gallery-wrap wrap-effect-1">
                  <div
                    className="item"
                    onMouseEnter={() => handleItemHover(0)}
                    style={{
                      flex: isItemHovered === 0 ? 7 : "1",
                      display: "flex",
                      alignItems: "end",
                      justifyContent: "center",
                      width: "120px",
                    }}
                  >
                    {isItemHovered === 0 ? (
                      <div
                        style={{
                          display: "flex",
                          width: "100%",
                          alignItems: "center",
                          justifyContent: "space-between",
                          padding: "30px",
                        }}
                      >
                        <div className="energy">Energy</div>
                        <div>
                          <img src={img1} alt="accord" />
                        </div>
                      </div>
                    ) : (
                      <div className="rotated-text">Energy</div>
                    )}
                  </div>
                  <div
                    className="item"
                    onMouseEnter={() => handleItemHover(1)}
                    style={{
                      flex: isItemHovered === 1 ? 7 : "1",
                      display: "flex",
                      alignItems: "end",
                      justifyContent: "start",
                      width: "120px",
                    }}
                  >
                    {isItemHovered === 1 ? (
                      <div
                        style={{
                          display: "flex",
                          width: "100%",
                          alignItems: "center",
                          justifyContent: "space-between",
                          padding: "30px",
                        }}
                      >
                        <div className="energy">Sports</div>
                        <div>
                          <img src={img2} alt="accord" />
                        </div>
                      </div>
                    ) : (
                      <div className="rotated-text">Sports</div>
                    )}
                  </div>
                  <div
                    className="item"
                    onMouseEnter={() => handleItemHover(2)}
                    style={{
                      flex: isItemHovered === 2 ? 7 : "1",
                      display: "flex",
                      width: "120px",
                      alignItems: "end",
                      justifyContent: "center",
                    }}
                  >
                    {isItemHovered === 2 ? (
                      <div
                        style={{
                          display: "flex",
                          width: "100%",
                          alignItems: "center",
                          justifyContent: "space-between",
                          padding: "30px",
                        }}
                      >
                        <div style={{ textAlign: "start" }} className="energy">
                          Petro <br /> Chemical
                        </div>
                        <div>
                          <img src={img1} alt="accord" />
                        </div>
                      </div>
                    ) : (
                      <span className="rotated-text">Petro Chemical</span>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <Stack data-aos="fade-up" data-aos-duration="3000" justifyContent={"center"} align="center" direction="row">
          {/* <Switch colorScheme='red' size="lg" /> */}
          <ToggleBtn />
          <Text className="tgl-btn" textAlign={"center"}>
            View All
          </Text>
        </Stack>
      </section>
    </>
  );
};

export default Accordion;
